import React from "react";
import Layout from "../../Layout/Layout";
import Section011 from "./Section011";
import Section022 from "./Section022";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async"; 
const ContactUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Helmet>
              <title>Contact RAH Shipping - Call +971-4-3204766 for Support</title>
              <meta name="description" content="
      
Get in touch with RAH Shipping & Logistics for expert freight solutions in Pakistan, NL & UAE. Call us at +971-4-3204766 for inquiries and support." />
              
            </Helmet>
      <Section011 />

      <Section022 />
    </Layout>
  );
};

export default ContactUsPage;
